import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ButtonBase from '@mui/material/ButtonBase';
import Box from '@mui/material/Box';

// project imports
import Logo from './inbriefFullWhiteR.svg';
import LogoIcon from './LogoIcon';
import { getSubRoot } from '../../utils/utils.jsx'; 

export default function LogoSection({ isIcon, sx, to }) {
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={getSubRoot(window.location.pathname)}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'min(100%,8vw)', 
        height: 'auto',
        overflow: 'hidden', 
        borderRadius: 1, 
        ...sx 
      }}
    >
      {!isIcon ? (
        <Box
          component="img"
          src={Logo}
          alt="Logo"
          sx={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            display: 'block',
            animation: 'fadeIn 1.5s ease-in-out', 
            '@keyframes fadeIn': {
              '0%': {
                opacity: 0,
              },
              '100%': {
                opacity: 1,
              },
            },
          }}
        />
      ) : (
        <Box
          sx={{
            animation: 'fadeIn 1.5s ease-in-out', 
            '@keyframes fadeIn': {
              '0%': {
                opacity: 0,
              },
              '100%': {
                opacity: 1,
              },
            },
          }}        
        >
          <LogoIcon />
        </Box>
      )}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
